import { useEffect } from "react";
import { useAppFormContext } from "../rhf/FormProvider";
import { useWatch } from "react-hook-form";
import { isValidValue } from "utils";
import { getPath } from "../rhf/rules";
import { markTouched } from "../rhf/useAppForm";
import { pocWatchedFields } from "../utils/addPocControl";

const isFilled = (v) => isValidValue(v) && v !== "";

/**
 * State for one POC accordion on react-hook-form: its value, whether it is
 * valid/touched (for the "Completed / Not Completed" chip), and the optional
 * POC behaviour from attachDynamicRequiredValidator: as soon as one field has
 * a value, the other empty fields are marked touched so their "required"
 * errors show.
 */
const usePocGroup = (path, role, status, arr) => {
  const form = useAppFormContext();
  const value = useWatch({ name: path });
  const valueKey = JSON.stringify(value ?? null);

  useEffect(() => {
    if (!value || status) return;
    const watched = pocWatchedFields(role, arr);
    const hasAnyValue = watched.some((label) => isFilled(value[label]));
    watched.forEach((label) => {
      if (hasAnyValue && !isFilled(value[label])) {
        markTouched(form, `${path}.${label}`);
      }
    });
    form.trigger(watched.map((label) => `${path}.${label}`));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [valueKey]);

  const { touchedFields, isSubmitted } = form.formState;
  return {
    value: value ?? {},
    valid: form.isPathValid(path),
    touched: !!getPath(touchedFields, path) || isSubmitted,
  };
};

export default usePocGroup;
